import { Modal, Button } from "react-bootstrap";
import styles from "../buttons/Button.module.css";
import Buttons from "../buttons/Buttons";

const ModalComponent = ({ show, onHide, title, bodyText, buttontext }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{bodyText}</Modal.Body>
      <Modal.Footer>
        <Buttons
          style={{
            fontSize: "18px",
            background: "linear-gradient(180deg, #FA8316, #7d4207)",
            // border: "none",
            // color: "#fff",
          }}
          onClick={onHide}
          text={buttontext}
        >
        </Buttons>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
